import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PublicTicketsService {
  constructor(private http: PublicHttpClientService) {}

  contract_form(
    text: any,
    ticketable_type: string,
    ticketable_id: string | number,
    form_type: string
  ): Observable<any> {
    const options = {
      form_params: {
        body: text,
        ticketable_type: ticketable_type,
        ticketable_id: ticketable_id,
        form_type: form_type,
      },
    };
    return this.http
      .post("/api/public/tickets/contract_form", options)
      .pipe(tap((_) => console.log("PublicTicketsService.contractForm: Ok.")));
  }
}
